import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { locationsCrudStateConfig } from "../../../consts";

const locationCrudStateReducer = makeCrudStateReducer(locationsCrudStateConfig);

export default locationCrudStateReducer;
